import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "../../appUtils/axiosConfig";

const initialState = {
    user: null,
    isLoggedIn: false,
    isLoading: false,
    isLoginLoading: false,
    error: null,
    isAuthenticated: null,
};

function saveUserData(responseData) {
    localStorage.setItem("userId", responseData?.user?._id);
    localStorage.setItem("userImage", responseData?.user?.image);
    localStorage.setItem("token", responseData?.token);
}


export const loginUser = createAsyncThunk(
    "auth/loginUser",
    async ({ password, email }, { dispatch, rejectWithValue }) => {
        console.log('data os login user is ', password, email)
        const userData = { password, email }
        console.log('user data ', userData)
        try {
            dispatch(loginStart());
            const response = await axios.post(`/auth/login.php`, userData);
            saveUserData(response.data);
            dispatch(loginSuccess(response.data?.user));
            if (response?.data?.success == true) {
                // SHOW_SUCCESS_NOTIFICATION("Login Successfully");
            }
            // return response.data
        } catch (error) {
            dispatch(loginFailure(error.response.data.message));
            // SHOW_ERROR_NOTIFICATION(error.response.data.message);
            return rejectWithValue(error.response.data.message);
        }
    }
);

const authSlice = createSlice({
    name: "auth",
    initialState,
    reducers: {
        loginStart(state) {
            state.isLoginLoading = true;
            state.error = null;
            state.isAuthenticated = false;
        },
        loginSuccess(state, action) {
            state.user = action.payload;
            state.isLoggedIn = true;
            state.isLoginLoading = false;
            state.isAuthenticated = true;
        },
        loginFailure(state, action) {
            state.error = action.payload;
            state.isLoginLoading = false;
            state.isAuthenticated = false;
        },
    }
})

export const {
    loginStart,
    loginSuccess,
    loginFailure,
} = authSlice.actions;

export default authSlice.reducer;